var _ = require('underscore');
module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="Bubble-container u-flex u-justifySpace">\n  <ul class="Bubble-numbers u-flex u-justifySpace">\n    ';
 if (hasCustomLabels) { ;
__p += '\n      <li class="Bubble-numbersItem CDB-Text CDB-Size-small" style="bottom: 0%">' +
__e( labels[1] ) +
'</li>\n      <li class="Bubble-numbersItem CDB-Text CDB-Size-small" style="bottom: 100%">' +
__e( labels[0] ) +
'</li>\n    ';
 } else { ;
__p += '\n      ';
 for (var i = 0; i<labels.length; i++) { ;
__p += '\n        <li class="Bubble-numbersItem CDB-Text CDB-Size-small" style="bottom: ' +
__e( labelPositions[i] ) +
'%">' +
((__t = ( formatter.formatNumber(labels[i]) )) == null ? '' : __t) +
'</li>\n      ';
 } ;
__p += '\n    ';
 } ;
__p += '\n  </ul>\n\n  <div class="Bubble-inner">\n    <ul class="Bubble-list ';
 if (hasCustomLabels && labels[1] === '') { ;
__p += 'Bubble-list--custom';
 } ;
__p += '">\n      ';
 for (var i in bubbleSizes) { ;
__p += '\n        ';

          var customCssClass = '';
          var index = +i;
          if (hasCustomLabels) {
            customCssClass = (labels[0] !== '' && index === 0) ? '' : 'Bubble-item--custom';
          }
        ;
__p += '\n        <li class="js-bubbleItem Bubble-item ' +
__e( customCssClass ) +
'" style="height: ' +
__e( bubbleSizes[i] ) +
'%; width: ' +
__e( bubbleSizes[i] ) +
'%">\n          <span class="Bubble-itemCircle" style=" ' +
__e( fillColor ? 'opacity:1; background-color:' + fillColor + ';': '') +
'" ></span>\n        </li>\n      ';
 } ;
__p += '\n    </ul>\n    <p class="Bubble-average CDB-Text CDB-Size-small u-altTextColor ';
 if (hasCustomLabels) { ;
__p += 'Bubble-average--custom';
 } ;
__p += '" style="bottom: ' +
__e( avgSize ) +
'%;">\n      ';
 if (!hasCustomLabels) { ;
__p += ' AVG: ' +
((__t = ( formatter.formatNumber(avgLabel) )) == null ? '' : __t) +
' ';
 } ;
__p += '\n    </p>\n  </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/ui/legends/bubble/legend-template.tpl
// module id = 2062
// module chunks = 6